// @core/api/endpoints/calendar/register_calendar_event_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarEventTypeDefinitionResponse,
  RegisterCalendarEventTypeRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Register calendar event type
 * Registers a new calendar event type definition. Products call this to declare their calendar-aware entity types (e.g., staffing.shift, booking.service_appointment, property.showing). Once registered, CalendarService will handle scheduling, availability blocking, and reminders for entities of this type.
 */
export async function RegisterCalendarEventType(
  data: RegisterCalendarEventTypeRequest,
  options?: RequestOptions
): Promise<CalendarEventTypeDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/calendar-event-types`;
  const requestOptions = options;
  return client.post<CalendarEventTypeDefinitionResponse>(requestPath, data, requestOptions);
}
